import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'uc-filter-dark-overlay',
	templateUrl: './filter-dark-overlay.component.html',
	imports: [NgClass],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDarkOverlayComponent {
	showOverlay = input.required<boolean>();
}
